import { ReactComponent as IconCard } from "./icon-card.svg";

export default IconCard;
